import { Button } from '@blueprintjs/core'
// TODO - Documentar
import React, { useEffect, useState } from 'react'
import { makePositionReport } from '../../utils/reportFunctions'


// Global constants
import * as con from '../../GlobalConstants'

// Style
import '../ComponentsGlobalStyle.css'


import LoadingIconSmall from '../../templates/loading/LoadingIconSmall';
import { AllApplicationParametersHook, RefApplicationParameterHook } from '../hooks/ApplicationParametersHooks';
import { ScenariosSelect } from '../parameters/SingleParameters';
import { RefTransactionsSummaryTableHook } from '../hooks/TransactionsSummaryTableHook'
import { useDispatch, useSelector } from 'react-redux'
import { RefMarketValueHook } from '../hooks/MarketValuesHook'
import { makeSelectScenarioGeneratorById } from '../../store/selectors/scenariosSlectors'

function PositionReport() {

    const dispatch = useDispatch()

    // Position Report
    const positionReport = RefApplicationParameterHook(con.POSITION_REPORT)

    // Has PositionReport
    const [hasPositionReport, setHasPositionReport] = useState(() => false)

    // eslint-disable-next-line
    const [transactionSummaryObject, summaryRow, computing, hasSummaryTable] = RefTransactionsSummaryTableHook()
    
    const modelApplicationParameters = AllApplicationParametersHook();
    const volatility = RefMarketValueHook(con.MARKET_VOLATILITY)
    const selectedScenarioId = RefApplicationParameterHook(con.SELECTED_SCENARIO)
    const scenario = useSelector(makeSelectScenarioGeneratorById(selectedScenarioId))
    useEffect(() => {
      
        setHasPositionReport(hasSummaryTable)

    }, [hasSummaryTable])
    

    return (
        <div className="columnParameterBoxTop">

            <h3>Reporte Posición Actual</h3>

            <ScenariosSelect />
            
            <div>                
              <Button disabled={!hasPositionReport || positionReport === con.GENERATING} 
                      onClick={async () => await dispatch(makePositionReport({modelApplicationParameters, volatility, scenario} )).unwrap()}
                      title={hasPositionReport ? null :  con.NO_TRANSACTIONS_MESSAGE}>Generar Reporte</Button>  
            </div>
            <div style={{width : "20px" , marginTop: "15px"}}>
            {
                positionReport === con.GENERATING
                && <LoadingIconSmall/> 
            }
            </div>
        </div>
    )
}

export default PositionReport
